<template>
  <div>

    <div class="user_module">
      <div class="module_head">
        <div>
          申报关注
        </div>
      </div>
      <div class="module_tab_cont sb_fav">
        <el-table :data="tablelist" stripe @cell-click="toDetail" style="width: 100%">
          <el-table-column prop="title" label="申报名称" width="320px"></el-table-column>
          <el-table-column prop="level" label="申报层级"></el-table-column>
          <el-table-column prop="published_time" label="发布时间"></el-table-column>
          <el-table-column prop="create_time" label="关注时间"></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getFavList();
  },
  name: 'userfav',
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      tablelist: [],
      options: [{
        value: '选项1',
        label: '2020'
      }, {
        value: '选项2',
        label: '2019'
      }, {
        value: '选项3',
        label: '2018'
      }],
      year: '2020',
      total:0
    }
  },
  methods: {
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getFavList()
    },
    toDetail(row, column, event, cell) {
      this.$router.push({name: 'notidetail', query: {id: row.object_id}})
    },
    async getFavList() {

      let res = await this.$ajax.get(this.bUrl + 'api/user/favorites/my?page=' + this.currentPage + '&pagesize='+this.pagesize + '&type=1');
      if(res.data.code!=200){ this.$message.error(res.data.msg); }
      this.tablelist = res.data.data.list;
      this.total = res.data.data.total;
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 18px;
  color: #143367;
}

.module_tab_cont {
  margin-top: 25px;
}

.module_addi {
  width: 100%;
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: space-between;
}

.ci_modify {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userfav.vue